import palette from '../../theme/palette'

export const inputLabelStyle = {
	fontSize: '12px',
	lineHeight: '16px',
	color: palette.text.darkBlue,
	fontWeight: 'bold',
	'&.optional': {
		fontWeight: 'normal',
	},
}

export const labelTooltipContainerStyle = { display: 'flex', justifyContent: 'space-between' }

export const inputLabelContainerStyle = {
	mb: '8px',
	fontSize: '12px',
}

export const modalSubtitleStyle = {
	fontSize: '12px',
	fontWeight: '500',
}

export const modalTitleStyle = {
	fontWeight: '600',
	fontSize: '22px',
	lineHeight: '40px',
	mb: '8px',
}

export const learnMoreStyle = {
	my: '16px',
	display: 'flex',
	alignItems: 'center',
	color: palette.brand.main,
	cursor: 'pointer',
	h3: {
		fontSize: '12px',
		fontWeight: 'normal',
		textDecoration: 'underline',
		textUnderlineOffset: '6px',
		color: palette.brand.main,
	},
	svg: {
		mr: '5px',
	},
}

export const refreshStyle = {
	...learnMoreStyle,
	my: '0px',
}

export const linkStyle = {
	textDecoration: 'underline',
	textUnderlineOffset: '6px',
	color: palette.brand.main,
}

export const testButtonStyle = {
	height: '50px',
	borderRadius: '12px',
	fontSize: '12px',
}

export const controlButtonsStyle = {
	m: 1,
	borderRadius: '8px',
	fontSize: '14px',
	px: '24px',
	py: '10px',
	my: '10px',
}
